import React from "react";
import { Code as ChakraCode } from "@chakra-ui/react";
export function Code({ children }) {
    return React.createElement(ChakraCode, null, children);
}
